import Rete from 'rete'

import { lang } from '../../assets/lang'
import CONST_SOCKET from '../../const/socket'
import lingualName from '../../const/lingualName'
import CONST_COMPONENT from '../../const/component'
import CarouselTemplate from './CarouselTemplate'

const instagram_addon = window.xitFlowBuilderData.instagram_addon

export default class CarouselComponent extends Rete.Component {
  constructor(config) {
    super(CONST_COMPONENT.CAROUSEL)

    this.data.component = CarouselTemplate
    this.socket = config ? config.sockets : null
    this.isUserInputFlowAddonAvailable = !! window.xitFlowBuilderData.user_input_flow_addon
  }

  builder(node) {
    node.lingualName = lingualName.CAROUSEL
    this.setConnection()

    const carouselInput = new Rete.Input(CONST_SOCKET.CAROUSEL_INPUT, lang.carousel_socket_input_reply, this.socket.carouselInput, true)
    const carouselOutput = new Rete.Output(CONST_SOCKET.CAROUSEL_OUTPUT, lang.carousel_socket_output_next, this.socket.carouselOutput, false)
    const carouselOutputItems = new Rete.Output(CONST_SOCKET.CAROUSEL_OUTPUT_ITEMS, lang.carousel_socket_output_items, this.socket.carouselOutputItems, true)
    const carouselOutputQuickreply = new Rete.Output(CONST_SOCKET.CAROUSEL_OUTPUT_QUICKREPLY, lang.carousel_socket_output_quick_replies, this.socket.carouselOutputQuickreply, true)

    node.addInput(carouselInput)
    node.addOutput(carouselOutput)
    node.addOutput(carouselOutputItems)

    if (! instagram_addon) {
      node.addOutput(carouselOutputQuickreply)
    }

    return node
  }

  // eslint-disable-next-line
  worker(node, inputs, outputs) {
    outputs[CONST_SOCKET.CAROUSEL_OUTPUT] = node.data
    outputs[CONST_SOCKET.CAROUSEL_OUTPUT_ITEMS] = node.data
  }
  
  setConnection() {
    // Carousel may take connections from:
    this.socket.carouselInput.combineWith(this.socket.referenceOutput)
    this.socket.carouselInput.combineWith(this.socket.newPostbackOutput)
    this.socket.carouselInput.combineWith(this.socket.textOutput)
    this.socket.carouselInput.combineWith(this.socket.carouselOutput)
    this.socket.carouselInput.combineWith(this.socket.facebookMediaOutput)
    this.socket.carouselInput.combineWith(this.socket.imageOutput)
    this.socket.carouselInput.combineWith(this.socket.videoOutput)
    this.socket.carouselInput.combineWith(this.socket.audioOutput)
    this.socket.carouselInput.combineWith(this.socket.fileOutput)
    this.socket.carouselInput.combineWith(this.socket.ecommerceOutput)
    this.socket.carouselInput.combineWith(this.socket.genericTemplateOutput)
    this.socket.carouselInput.combineWith(this.socket.otnOutput)

    // Carousel may be connected to:
    this.socket.carouselOutput.combineWith(this.socket.textInput)
    this.socket.carouselOutput.combineWith(this.socket.carouselInput)
    this.socket.carouselOutput.combineWith(this.socket.facebookMediaInput)
    this.socket.carouselOutput.combineWith(this.socket.imageInput)
    this.socket.carouselOutput.combineWith(this.socket.videoInput)
    this.socket.carouselOutput.combineWith(this.socket.audioInput)
    this.socket.carouselOutput.combineWith(this.socket.fileInput)
    this.socket.carouselOutput.combineWith(this.socket.ecommerceInput)
    this.socket.carouselOutput.combineWith(this.socket.genericTemplateInput)
    this.socket.carouselOutput.combineWith(this.socket.otnInput)
    this.socket.carouselOutput.combineWith(this.socket.componentListInput)

    if (this.isUserInputFlowAddonAvailable) {
      this.socket.carouselOutput.combineWith(this.socket.userInputFlowInput)
    }

    // Output (CarouselItem): CarouselItem
    this.socket.carouselOutputItems.combineWith(this.socket.carouselSingleInput)
    this.socket.carouselOutputQuickreply.combineWith(this.socket.quickReplyInput)    
  }
}